<template>
    <div></div>
</template>
<script>
import router from '@/router';
import axios from 'axios';

export default {
    name: 'logout',
    created() {
        localStorage.removeItem('hotel');
        localStorage.removeItem('chainHotels');
        localStorage.removeItem('reportUrl')
    },
    mounted() {
        axios({
            url: '/logout'
        }).then(() => {
            router.push({path: '/'});
        }).catch(error => {
            if (error) {
                error.forceShowError = true
            }
            this.showError(error)
        });
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/logout.vue